import { h, Component } from 'preact';
import HTML from 'components/core/html/html';
import Store from 'store/store';
import SectionBackground from 'components/bolt/sectionBackground/sectionBackground';
import { joinClasses } from 'utils/utils';
import parseQueryString from 'utils/parseQueryString';
import { getValueForClientSize } from 'utils/bolt';
import { getCookie } from 'utils/cookies';

import s from 'components/bolt/password/password.sss';

export default class PasswordPage extends Component {
	constructor(props) {
		super(props);

		const copy = props?.appData?.copy.baseCopy;

		const errorMessage = copy.$PASSWORD_ERROR_MESSAGE || 'Invalid submission';
		const passwordInputPlaceholder = copy.$PASSWORD_INPUT_PLACEHOLDER || 'Password';
		const passwordSubmitCta = copy.$PASSWORD_SUBMIT_CTA || 'Submit';
		const passwordFormInstructions = copy.$PASSWORD_INSTRUCTIONS || 'Enter password';
		this.pageData = this.props.appData?.pages[this.props.id].data;

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.clearInput = this.clearInput.bind(this);
		this.checkFailedAttempts = this.checkFailedAttempts.bind(this);
		this.dropFailedAttemptCookie = this.dropFailedAttemptCookie.bind(this);

		this.state = {
			value: '',
			showError: false,
			errorMessage: errorMessage,
			passwordInputPlaceholder: passwordInputPlaceholder,
			submitButtonCta: passwordSubmitCta,
			passwordFormInstructions: passwordFormInstructions,
			lockedOut: false
		};
		this.failedAttempts = typeof window === 'undefined' ? 0 : +getCookie('pow-password-attempts') || 0;
	}

	componentDidMount() {
		const query = parseQueryString();

		this.checkFailedAttempts(query);

		if (query.target) {
			let path = decodeURIComponent(query.target);
			this.destination = Object.values(this.props.appData?.pages || {}).find(page => page?.path === path || page?.path === path + '/')?.id;
		}
	}

	getFinalValue() {
		return this.state.value;
	}

	async handleSubmit(event) {
		event.preventDefault();

		// only works on prod but avoids cors errors if they cname the naked domain to our cloudfront
		// instead of redirecting to www like in our meta url
		// also this way it works on the cloudfront link too
		const url = window.location.origin;
		// const url = this.props.appData?.meta?.url;

		const pages = Object.values(this.props.appData?.pages || {}).filter(e => e);
		const passwordDestPage = pages.find(page => page.data?.passwordGatewayPageId);
		const passwordPath = this.props.appData?.pages?.[passwordDestPage?.data?.passwordGatewayPageId]?.path || '/password';
		let destination = this.destination || passwordDestPage?.id;
		const value = this.getFinalValue();

		try {
			let res = await fetch(url + passwordPath + 'api-password', {
				headers: { 'x-pow-password': value }
			});
			let data = await res.json();
			if (data?.success) {
				if (this.props.isSection) {
					Store.emit('PASSWORD_ACCEPTED', this.props.sectionId);
				} else if (destination) {
					Store.emit('CLOSE_AND_NAVIGATE', destination);
				}
				return;
			}

			this.dropFailedAttemptCookie();
			this.clearInput();
			return this.setState({ showError: true });
		} catch (e) {
			console.error(e);
			this.dropFailedAttemptCookie();
			this.clearInput();
			this.setState({ showError: true });
		}
	}

	handleChange(event) {
		this.setState({ value: event.target.value });
	}

	clearInput() {
		window.setTimeout(() => {
			if (!this.input) {
				return;
			}
			this.input.value = '';
		}, 0);
	}

	checkFailedAttempts(query) {
		const isLocalOrDemo = __IS_LOCAL__ || __IS_DEMO__;
		const passwordProtectionDisabled = isLocalOrDemo && typeof query?.disablepasswordprotection !== 'undefined';

		const pages = Object.values(this.props.appData?.pages || {}).filter(e => e);
		const passwordDestPage = pages.find(page => page.data?.passwordGatewayPageId);
		let destination = this.destination || passwordDestPage?.id;

		if (passwordProtectionDisabled) {
			if (this.props.sectionId) {
				return Store.emit('PASSWORD_ACCEPTED', this.props.sectionId);
			}
			if (destination) {
				return Store.emit('CLOSE_AND_NAVIGATE', destination);
			}
		}

		const sectionUnlockedCookie = getCookie('pow-password');

		if (this.props.isSection && sectionUnlockedCookie) {
			const cookieData = sectionUnlockedCookie.split('.')[0];
			const hasPath = JSON.parse(cookieData).path.includes(this.props.sectionPath);
			if (hasPath) {
				Store.emit('PASSWORD_ACCEPTED', this.props.sectionId);
			}
		}

		const lockOutEnabled = this.pageData.lockout;

		if (!lockOutEnabled) {
			return;
		}

		const allowedAttempts = this.pageData.lockout?.attemptsAllowed || 3;

		if (this.failedAttempts >= allowedAttempts) {
			const lockoutMessage = lockOutEnabled.lockoutMessage;

			this.setState({
				lockedOut: true,
				errorMessage: lockoutMessage
			});
		}
	}

	dropFailedAttemptCookie() {
		this.failedAttempts += 1;
		const expiresInHours = this.pageData.expirationInSeconds;
		const expiresInSeconds = expiresInHours * 3600;
		const expirationTimestamp = new Date().getTime() + expiresInSeconds * 1000;
		document.cookie = 'pow-password-attempts=' + this.failedAttempts + '; Max-Age=' + expiresInSeconds + '; Expires=' + new Date(expirationTimestamp).toUTCString() + '; Same-Site=Strict; Path=/';

		this.checkFailedAttempts();
	}

	render(props, state) {
		const {
			value,
			showError,
			errorMessage,
			passwordInputPlaceholder,
			submitButtonCta,
			passwordFormInstructions,
			lockedOut
		} = state;

		return (
			<div class={joinClasses(s.wrapper, props.isSection && s.section)} data-section-id={props.sectionId}>
				{this.pageData.bg && <SectionBackground data={this.pageData.bg} key="bg" />}
				<div class={s.formWrapper} key="wrapper">
					{this.pageData.tt && <img class={s.tt} src={getValueForClientSize(this.pageData.tt, props.client)} alt={this.pageData.tt?.alt} key="tt" />}
					{!lockedOut && <HTML class={joinClasses(s.formInstructions, 'xlarge')} key="instructions">{passwordFormInstructions}</HTML>}
					{!lockedOut && (
						<form class={s.form} onSubmit={this.handleSubmit} key="form">
							<label key="label">
								<input
									ref={ref => this.input = ref}
									type="password"
									placeholder={passwordInputPlaceholder}
									class={joinClasses(s.inputBox, 'medium')}
									value={value}
									onInput={this.handleChange}
								/>
							</label>
							{showError && <div class={joinClasses(s.errorMessage, 'medium')} key="error">{errorMessage}</div>}
							<input type="submit" class={joinClasses(s.submitButton, 'mediumB')} value={submitButtonCta} key="submit" />
						</form>
					)}
					{lockedOut && <div class={joinClasses(s.errorMessage, 'medium')} key="error">{errorMessage}</div>}
				</div>
			</div>
		);
	}
}
